(ns frontend.test.validation.sub
  (:require
   [common.util :as cu]
   [re-frame.core :as rf]
   [frontend.test.validation.utils :as utils]
   [frontend.test.validation.model :as m]))

(rf/reg-sub
 ;; Don't use directly - identity (:ident) needed
 m/root-state
 (fn [db _]
   (get db m/root)))

(rf/reg-sub
 ;; State, specific to a single instance
 m/state
 (fn [[_ _args]]
   {:root-state (rf/subscribe [m/root-state])})
 (fn [{:keys [root-state]}
      [_ {:keys [ident]}]]
   (if (coll? ident)
     (get-in root-state ident)
     (get root-state ident))))

(defn edits
  [{:keys [state]} _]
  (get state m/edits-key))

(rf/reg-sub
 m/edits
 (fn [[_ ctx]]
   {:state (rf/subscribe [m/state ctx])})
 edits)

(defn entity-edits
  [{:keys [edits]} [_ {:keys [entity-id]}]]
  (get edits entity-id))

(rf/reg-sub
 m/entity-edits
 (fn [[_ ctx]]
   {:edits (rf/subscribe [m/edits ctx])})
 entity-edits)

(defn entity-value
  [{:keys [entity-edits]} [_ {:keys [attribute]}]]
  (get entity-edits attribute))

(rf/reg-sub
 m/entity-value
 (fn [[_ ctx]]
   {:entity-edits (rf/subscribe [m/entity-edits ctx])})
 entity-value)

(defn validate-constraint
  [_context [constraint-key c-val] value]
  (case constraint-key
    :constraint/mandatory-fn
    (when (c-val value nil)
      {:error-kw :mandatory
       :error-message "Mandatory field must contain value"})
    :constraint/string-min-length
    (when (< (count (cu/str-trim-lcase value)) 2)
      {:error-kw :min-length
       :error-message (str "Must be at least " c-val " characters")})
    :constraint/unique-name
    (when (= (cu/str-trim-lcase value) "hello")
      {:error-kw :unique-name
       :error-message "The name must be unique"
       :conflicting-id 17592186064185})
    nil))

(defn entity-value-errors
  [{:keys [entity-value]} [_ {:keys [attribute]}]]
  (let [{:keys [constraints] :as _defs} (get m/attribute-defs-by-attribute attribute)]
    (->> constraints
         (mapv (fn [constraint]
                 (validate-constraint {:entity nil :etc :info}
                                      constraint entity-value)))
         (filterv some?)
         ;; not-empty retains type:
         not-empty)))

(rf/reg-sub
 m/entity-value-errors
 (fn [[_ ctx]]
   {:entity-value (rf/subscribe [m/entity-value ctx])})
 utils/entity-value-errors)

;;TODO handles only one entity - a form might require validating multiple entities
(defn validate-all
  [{:keys [entity-edits] :as args} [_ ctx]]
  ;;TODO reduce m/attribute-defs, attach each validation to key
  (->> m/attribute-defs
       (mapv (fn [{:keys [attribute]}]
               [attribute (entity-value-errors {:entity-value (get entity-edits attribute)}
                                               [nil (assoc ctx :attribute attribute)])]))
       (filterv (comp some? second))
       (into {})
       not-empty))

(rf/reg-sub
 m/validate-all
 (fn [[_ ctx]]
   {:entity-edits (rf/subscribe [m/entity-edits ctx])})
 utils/validate-all)

(defn state-errors
  [{:keys [state]} _]
  (prn ">state-errors")
  (get state m/errors-key))

(rf/reg-sub
 m/state-errors
 (fn [[_ ctx]]
   {:state (rf/subscribe [m/state ctx])})
 state-errors)

(defn state-entity-errors
  [{:keys [errors]} [_ {:keys [entity-id]}]]
  (prn ">state-entity-errors")
  (get errors entity-id))

(rf/reg-sub
 m/state-entity-errors
 (fn [[_ ctx]]
   {:errors (rf/subscribe [m/state-errors ctx])})
 state-entity-errors)

(defn state-entity-value-errors
  [{:keys [entity-errors]} [_ {:keys [attribute]}]]
  (prn ">state-entity-value-errors")
  (get entity-errors attribute))

(rf/reg-sub
 m/state-entity-value-errors
 (fn [[_ ctx]]
   {:entity-errors (rf/subscribe [m/state-entity-errors ctx])})
 state-entity-value-errors)



(comment

  ;; Initial helpers for association type selectors

  (defn invert-to-set [[et other-ets-associations]]
    [et (->> other-ets-associations
             (mapv (fn [[et associations]]
                     (->> associations
                          (mapv (fn [[association _]]
                                  [association #{et}]))
                          (into {}))))
             (apply merge-with clojure.set/union))])

  ;; instead of shape
  ;; [entity-type other-entity-type map-of-association-types]
  ;; change into
  ;; [entity-type association-type set-of-other-entity-types]
  ;; e.g.
  ;; {:et/oppo {:et/company {:at/other {}}
  ;;            :et/person {:at/other {}} ,,,} ,,,}
  ;; => {:et/oppo :at/other #{:et/company :et/person}}
  (def et-options-by-association-type
    (->> common.schema.associations/schema
         (mapv invert-to-set)
         (into {})))

  (->> et-options-by-association-type
       (mapv (fn [[et ass]]
               [et (->> ass
                        (filterv (fn [[at ets]]
                                   (cu/multiple? ets)))
                        (mapv (fn [[at ets]]
                                [at (count ets)]))
                        (into {}))]))
       (filterv (fn [[et ass]]
                  (seq ass)))
       (into {}))

  :rcb)
